export const VARIABLES = {
    // url : "http://178.128.196.165:8010",
    // url :"http://192.168.0.123:8000",
    url : "https://zs-api-test.techwalnut.co.in", 
    // url : "https://demozs-api.elorca.com",
    mqtt_client_test : "11", 
    subdomain : "zoomsolar",
    // subdomain : "demoprojects",
    // project_id : "3ABE4F1A",
    project_id : "AD0E9446",
    node_id : "9D91C697",
    ca : "/zs-dashboard/certs/fullchain.pem",
    cert : "/zs-dashboard/certs/fullchain.pem",
    key : "/zs-dashboard/certs/privkey.pem"
}; 